import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import rolesAdminService from "services/admin/rolesService";
import { useForm } from "react-hook-form";
import permissionsAdminService from "services/admin/permissionsService";
import { Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const RoleForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { role, permissions },
}) => {
  const { t } = useTranslation()

  const { register, handleSubmit, formState: { errors }, watch } = useForm({
    defaultValues: {
      name: role?.name,
      permissions: permissions.map((permission) => {
        return {
          id: permission.id,
          name: permission.name,
          value: role?.permissions?.map((p) => p.id).includes(permission.id),
        }
      }),
    },
  });

  const onSubmit = async (formValues) => {
    try {
      if (role) {
        await rolesAdminService.put(id, formValues)
        snack("Роль обновлен успешно!");
      } else {
        await rolesAdminService.post(formValues)
        snack("Роль создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  const buildPermissionsFields = () => {

    // Group permissions by resource
    const groupedPermissions = permissions.reduce((acc, permission) => {
      acc[permission.resource] = acc[permission.resource] || []
      acc[permission.resource].push(permission)
      return acc
    }, {})

    return Object.entries(groupedPermissions).map(([resource, resourcePermissions]) => {
      return (
        <div className="form-group m-b-32">
          <h3 className="fs-20 text-bold m-b-16">{t(resource)}</h3>
          {resourcePermissions.map((permission) => {
            const inx = permissions.findIndex((p) => p.id === permission.id);
            return (
              <div className="form-group flex gap-2 align-items-center m-b-8">
                <input type="checkbox" id={permission.id} name={permission.id} {...register(`permissions.${inx}.value`)} />
                <label style={{
                  marginLeft: 4,
                }} htmlFor={permission.id}>{permission.name}</label>
              </div>
            )
          })}
        </div>
      )
    })
  }

  return (
    <CrudPage title={role ? 'Редактирование роли' : 'Создание роли'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group m-b-32">
          <TextField fullWidth label="Название" type="text" id="name" name="name" {...register("name")} />
        </div>
        {buildPermissionsFields()}
        <Button variant="contained" type="submit">Сохранить</Button>
        {/* <pre>
          {JSON.stringify(watch(), null, 2)}
        </pre> */}
      </form>
    </CrudPage >
  );
};

export default withRouter(
  withRemoteDataAndSpinner(RoleForm, (router) => {
    let requests = {
      permissions: () => permissionsAdminService.getAll(),
    }

    if (router.params.id) {
      requests['role'] = () => rolesAdminService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
